import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solutions() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/oz-leasing/solution_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={757}
              height={587}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#2B8FE8" }}>Solution</span>
            </h2>
            <p>
              We gathered our team of creative experts and tech geniuses and
              began our creative journey to help Michael achieve his vision. We
              created a lean and interactive platform careful to highlight core
              features that were most important to users.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutions;
